import { Typography, Box, Button } from '@mui/material'
import { NetworkBatchTable } from './NetworkBatchTable';
import apiClient from '../../apiClient';
import { getStore } from '../../Store'
const store = getStore();

const BatchResults = () => {
    const syncNetworkBatches = (network_batch_id) => {
        store.updateStatusMessage("Syncing all network batches...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Sync_Batch_Data",
            }
        ).then(({ data }) => {
            store.updateSuccessMessage("Successfully synced network batches!")
            window.location.reload();
        }).catch(function (error) {
            store.updateErrorMessage("Error: " + error)
        })
    }

    const CreateNetworkBatchButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"create-network-batch"}
        >
            Create Network Batch
        </Button>
    const SyncAllBatchesButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            onClick={() => syncNetworkBatches()}
        >
            Sync Batch Data
        </Button>
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Network Batches</Typography>
                </Box>
                <Box>
                    <SyncAllBatchesButton />
                    <CreateNetworkBatchButton />
                </Box>
            </Box>
            <div style={{ height: '750px', width: '100%', marginBottom: 16 }}>
                <NetworkBatchTable />
            </div>
        </div>
    )
}

export default BatchResults;